<template>
  <VaSelect
    v-model="currentLanguage"
    :options="languageOptions"
    style="width: 140px"
    @update:modelValue="onLanguageChange"
  >
    <template #content="{ value: option }">
      <div class="flex items-center">
        <img
          :src="(option as LanguageOption)?.flag"
          :alt="(option as LanguageOption)?.text"
          style="height: 20px; width: 30px; object-fit: cover;"
          class="mr-2"
        />
        <span class="text-sm">{{ (option as LanguageOption)?.text }}</span>
      </div>
    </template>
    <template #option="{ option }">
      <div class="flex items-center px-2 py-1 w-full cursor-pointer" @click="onLanguageChange(option as LanguageOption)">
        <img
          :src="(option as LanguageOption).flag"
          :alt="(option as LanguageOption).text"
          style="height: 20px; width: 30px; object-fit: cover;"
          class="mr-2"
        />
        <span class="text-sm">{{ (option as LanguageOption).text }}</span>
      </div>
    </template>
  </VaSelect>
</template>

<script lang="ts" setup>
import { VaSelect } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { ref, computed, onMounted } from 'vue'

interface LanguageOption {
  text: string
  value: string
  flag: string
}

const { locale, t } = useI18n()

const languageOptions = computed<LanguageOption[]>(() => [
  { text: t('language.turkish'), value: 'tr', flag: '/flags/tr.svg' },
  { text: t('language.english'), value: 'en', flag: '/flags/en.svg' },
])

const currentLanguage = computed<LanguageOption>({
  get: () => languageOptions.value.find((lang) => lang.value === locale.value) || languageOptions.value[0],
  set: (selectedOption) => {
    if (selectedOption) {
      locale.value = selectedOption.value
      localStorage.setItem('language', selectedOption.value)
    }
  },
})

const onLanguageChange = (selectedOption: LanguageOption | null | undefined) => {
  console.log('selectedOption', selectedOption)
  if (selectedOption) {
    locale.value = selectedOption.value
    localStorage.setItem('language', selectedOption.value)
  }
}

onMounted(() => {
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage) {
    locale.value = savedLanguage
  }
})
</script> 